export const SAVE_INTEREST_ENHANCEMENT = 'SAVE_INTEREST_ENHANCEMENT'
export const SAVE_INTEREST_ENHANCEMENT_ACCOUNTS = 'SAVE_INTEREST_ENHANCEMENT_ACCOUNTS'
export const SAVE_INTEREST_ENHANCEMENT_COUNTRY_LIST = 'SAVE_INTEREST_ENHANCEMENT_COUNTRY_LIST'
export const SAVE_INTEREST_ENHANCEMENT_CURRENCY = 'SAVE_INTEREST_ENHANCEMENT_CURRENCY'
export const SET_PREMIUM_MARGIN_VALUE = 'SET_PREMIUM_MARGIN_VALUE'
export const DELETE_FROM_DETAIL_SETTING = 'DELETE_FROM_DETAIL_SETTING'
export const SET_IE_TAB_STATUS = 'SET_IE_TAB_STATUS'
export const SET_DELETED_TIER_INDEX = 'SET_DELETED_TIER_INDEX'
export const RESET_DELETED_TIER_INDEX = 'RESET_DELETED_TIER_INDEX'



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/actions/actionTypes.js